<template>
  <v-sheet class="pb-16 ma-2" outlined>
    <!-- 상단 제목 -->
    <p class="pt-6 font-weight-bold text-center text-h5 grey--text text--darken-2">관리자 로그인</p>
    <v-divider class="mx-4"></v-divider>

    <!-- 본문 -->
    <v-sheet class="mt-10">
      <v-sheet width="300" class="my-10 mx-auto">
        <!-- 로고 & 문구 -->
        <v-img height="40" width="140" class="mx-auto mb-2" contain src="@/assets/logo/main.svg"></v-img>
        <p class="mb-6 text-center font-weight-medium text-body-1 primary--text">관리자 페이지</p>

        <!-- 아이디 -->
        <v-text-field
          outlined
          flat
          dense
          autofocus
          color="primary"
          placeholder="아이디"
          v-model="user_id"
          @change="$v.user_id.$touch()"
          @blur="$v.user_id.$touch()"
          :error-messages="user_id_Errors"
          @keyup.enter="submit()"
        ></v-text-field>

        <!-- 비밀번호 -->
        <v-text-field
          outlined
          flat
          dense
          color="primary"
          placeholder="비밀번호"
          type="password"
          v-model="password"
          @change="$v.password.$touch()"
          @blur="$v.password.$touch()"
          :error-messages="password_Errors"
          @keyup.enter="submit()"
        ></v-text-field>

        <!-- 로그인 -->
        <v-btn style="width: 100%" class="font-weight-bold" color="primary" dark large depressed @click="submit()"> 로그인 </v-btn>
      </v-sheet>
    </v-sheet>
  </v-sheet>
</template>
<script>
import { validationMixin } from "vuelidate"
import { required } from "vuelidate/lib/validators"
import { mapActions } from "vuex"

export default {
  mixins: [validationMixin],

  validations: {
    user_id: {
      required,
    },
    password: {
      required,
    },
  },

  data: () => ({
    user_id: "",
    password: "",
  }),

  computed: {
    user_id_Errors() {
      const errors = []
      if (!this.$v.user_id.$dirty) return errors
      !this.$v.user_id.required && errors.push("아이디를 입력해주세요")
      return errors
    },
    password_Errors() {
      const errors = []
      if (!this.$v.password.$dirty) return errors
      !this.$v.password.required && errors.push("비밀번호를 입력해주세요")
      return errors
    },
  },

  methods: {
    ...mapActions(["login"]),

    async submit() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const trimmedUserId = this.user_id.trim()
      this.user_id = trimmedUserId

      try {
        const jwtResponse = await this.login({
          user_id: trimmedUserId,
          password: this.password,
        })

        if (!jwtResponse?.success) {
          alert(jwtResponse?.message || "아이디 또는 비밀번호가 잘못되었습니다.")
          return
        }

        const userType = (jwtResponse?.user?.userType || "").toLowerCase()
        if (!["admin", "staff"].includes(userType)) {
          await this.$store.dispatch("logout")
          alert("관리자 권한이 없습니다.")
          return
        }

        this.$router.push("/admin/lafia_castle")
      } catch (error) {
        alert(error?.response?.data?.message || "아이디 또는 비밀번호가 잘못되었습니다.")
      }
    },
  },
}
</script>
